import React from "react";
import { Accordion } from "react-bootstrap";

function AccordionComponent({ header, children }) {
  return (
    <Accordion>
      <Accordion.Item eventKey="0">
        <Accordion.Header>{header}</Accordion.Header>
        <Accordion.Body>{children}</Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
}

export default AccordionComponent;
